export default require('../otherChains/unichainSepolia').default.rpcUrls.default.http[0]